import { render, staticRenderFns } from "./ImportProduct.vue?vue&type=template&id=2102441b"
import script from "./ImportProduct.vue?vue&type=script&lang=js"
export * from "./ImportProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports